import React, { useState } from 'react'
import * as yup from 'yup'
import Form, { useForm } from '@zera-admin/form'
import { Column, Row } from '@zera-admin/page'
import Modal from '@zera-admin/modal'
import Select, { SelectOptionProps } from '@zera-admin/select'

import { useFlagcardContext } from 'app/contexts/flagcard'
import { validation } from 'app/functions'
import { genderType } from 'app/shared/constants'
import genderDataSetsService, {
  CreateGenderDataSetRequest,
} from 'services/http/dataset/gender-data-set'

import { GenderDataSetProps } from '../types'

const validations = {
  genderType: yup.string().required('Cinsiyet seçmelisiniz'),
}

const GenderDataSet: React.FunctionComponent<GenderDataSetProps> = ({
  onClose,
  values,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [flagcard] = useFlagcardContext()

  const form = useForm<CreateGenderDataSetRequest>({
    initialValues: values,
    onValidate: async (values, prop) =>
      await validation(validations, values, prop),
  })

  const handleSubmit = () => {
    setIsLoading(true)
    genderDataSetsService
      .create(form.values)
      .then(() => {
        flagcard.add({
          appearance: 'success',
          title: 'Kayıt işlemi başarılı',
          children:
            'Girmiş olduğunuz bilgiler ile birlikte veri sisteme başarıyla kayıt edilmiştir. Dilerseniz yeni veri ekleyebilirsiniz.',
        })
        onClose?.()
      })
      .catch((error) => {
        console.log(error)

        flagcard.add({
          appearance: 'error',
          title: 'Bir hata oluştu',
          children:
            'Veri eklenirken bir hata oluştu. Lütfen tekrar deneyin. Sorununuz düzelmediyse servis sağlayıcısı ile iletişime geçiniz.',
        })
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  return (
    <Modal
      actions={[
        {
          appearance: 'primary',
          text: 'Kaydet',
          onClick: () => handleSubmit(),
          isLoading: isLoading,
        },
        {
          appearance: 'subtle',
          text: 'Vazgeç',
          onClick: onClose,
        },
      ]}
      width="medium"
      onClose={onClose}
      title="Cinsiyet veri seti eğitme"
    >
      <Form onSubmit={handleSubmit}>
        <Row xs={{ direction: 'column' }}>
          <Column>
            <Select
              errorMessage={form.errors.genderType}
              label="Cinsiyet seçiniz"
              name="genderType"
              value={genderType.find(
                (gender) => gender.value === form.values.genderType
              )}
              onChange={(props) =>
                form.handleFieldChange(
                  'genderType',
                  (props as SelectOptionProps).value
                )
              }
              options={genderType}
              position="fixed"
            />
          </Column>
        </Row>
      </Form>
    </Modal>
  )
}

export default GenderDataSet
